import { gql } from '@apollo/client';

export const getAgendaUser = gql /* GraphQL */ `
query GetAgendaUser($userId: ID!, $startAt: String, $stopAt: String, $now: String) {
    getAgendaUser(userId: $userId) {
      comId
      email
      firstName
      image
      isConfirmed
      language
      lastName
      profileOwner
      role
      suspended
      type
      hours
      timezone
      updatedAt
      userId
      username
      FCMtoken
      readedAt
      com {
        account_type
        address
        comId
        createdAt
        customer_id
        name
        phoneNumber
        planId
        image
        subscriptionId
        suspended
        type
        updatedAt
        userId
        __typename
      }
      shifts(filter: {startAt: {gt: $startAt}, and: [{stopAt: {lt: $stopAt}}, {stopAt: {gt: $now}}], deleted: {ne: true}, confirmed: {eq: true}}) {
        items {
            shiftId
            role
            info
            location
            startAt
            stopAt
            confirmed
            deleted
            __typename
        }
      }
      job: shifts(filter: {startAt: {gt: $startAt}, and: [{stopAt: {lt: $stopAt}}, {stopAt: {gt: $now}}], deleted: {ne: true}, accepted: {eq: false}, confirmed: {ne: true}}) {
        items {
            shiftId
            role
            info
            location
            startAt
            stopAt
            accepted
            deleted
            confirmed
            __typename
        }
      }
      requests(filter: {deleted: {ne: true}}) {
        items {
          userId
          deleted
          __typename
        }
      }
      __typename
    }
  }
  `;

  // shiftApps(filter: {startAt: {gt: $startAt}, and: [{stopAt: {lt: $stopAt}}, {stopAt: {gt: $now}}], confirmed: {ne: true}, deleted: {ne: true}}) {
  //       items {
  //         location
  //         shiftAppId
  //         startAt
  //         stopAt
  //         userId
  //         accepted
  //         confirmed
  //         deleted
  //         __typename
  //       }
  //     }

  export const comByUserId = gql/* GraphQL */ `
query ComByUserId(
  $filter: ModelAgendaCompanyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  comByUserId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      account_type
      address
      comId
      createdAt
      customer_id
      name
      phoneNumber
      suspended
      type
      updatedAt
      userId
      subscriptionId
      planId
      __typename
    }
    nextToken
    __typename
  }
}
`;

  // export const listAgendaPosts = gql /* GraphQL */ `
  // query ListAgendaPosts(
  //   $filter: ModelAgendaPostFilterInput
  //   $limit: Int
  //   $nextToken: String
  //   $postId: ID
  //   $sortDirection: ModelSortDirection
  // ) {
  //   listAgendaPosts(
  //     filter: $filter
  //     limit: $limit
  //     nextToken: $nextToken
  //     postId: $postId
  //     sortDirection: $sortDirection
  //   ) {
  //     items {
  //       comId
  //       createdAt
  //       deleted
  //       description
  //       postId
  //       userId
  //       __typename
  //     }
  //     nextToken
  //     __typename
  //   }
  // }
  // `;

export const updateAgendaUser = gql/* GraphQL */ `
mutation UpdateAgendaUser(
  $condition: ModelAgendaUserConditionInput
  $input: UpdateAgendaUserInput!
) {
  updateAgendaUser(condition: $condition, input: $input) {
    FCMtoken
    comId
    createdAt
    email
    firstName
    isConfirmed
    language
    lastName
    password
    phoneNumber
    profileOwner
    image
    role
    suspended
    type
    updatedAt
    userId
    username
    monday
    tuesday
    wednesday
    thursday
    friday
    saturday
    sunday
    night
    hours
    timezone
    __typename
  }
}
`;

export const createAgendaPunch = gql/* GraphQL */ `
mutation CreateAgendaPunch(
  $condition: ModelAgendaPunchConditionInput
  $input: CreateAgendaPunchInput!
) {
  createAgendaPunch(condition: $condition, input: $input) {
    accuracy
    altitude
    createdAt
    deleted
    heading
    latitude
    longitude
    punchId
    userId
    shiftId
    userId
    speed
    startAt
    stopAt
    timestamp
    updatedAt
    __typename
  }
}
`;

export const shiftAppsByUser = gql/* GraphQL */ `query ShiftAppsByUser(
  $filter: ModelAgendaShiftApplicationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
  $userId: ID!
) {
  shiftAppsByUser(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
    userId: $userId
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
      user {
        username
        type
        image
      }
    }
    nextToken
    __typename
  }
}
`;

export const shiftAppsByComId = gql/* GraphQL */ `query ShiftAppsByComId(
  $comId: ID!
  $filter: ModelAgendaShiftApplicationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
) {
  shiftAppsByComId(
    comId: $comId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    nextToken
    __typename
  }
}
`;

export const shiftsByUser = gql/* GraphQL */ `query ShiftsByUser(
  $filter: ModelAgendaShiftFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
  $userId: ID!
) {
  shiftsByUser(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
    userId: $userId
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      performance
      punctuality
      quality
      rate
      role
      shiftAppId
      shiftId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    nextToken
    __typename
  }
}
`;

// export const shiftsByUser = gql/* GraphQL */ `
// query ShiftsByUser(
//   $filter: ModelAgendaShiftFilterInput
//   $limit: Int
//   $nextToken: String
//   $sortDirection: ModelSortDirection
//   $startAt: ModelStringKeyConditionInput
//   $userId: ID!
// ) {
//   shiftsByUser(
//     filter: $filter
//     limit: $limit
//     nextToken: $nextToken
//     sortDirection: $sortDirection
//     startAt: $startAt
//     userId: $userId
//   ) {
//     items {
//       accepted
//       comId
//       confirmed
//       createdAt
//       deleted
//       info
//       location
//       role
//       shiftId
//       startAt
//       stopAt
//       suspended
//       updatedAt
//       userId
//       username
//       __typename
//     }
//     nextToken
//     __typename
//   }
// }
// `;

// export const shiftAppsByUser = gql/* GraphQL */ `
//   query ShiftAppsByUser(
//     $createdAt: ModelStringKeyConditionInput
//     $filter: ModelAgendaShiftApplicationFilterInput
//     $limit: Int
//     $nextToken: String
//     $sortDirection: ModelSortDirection
//     $userId: ID!
//   ) {
//     shiftAppsByUser(
//       createdAt: $createdAt
//       filter: $filter
//       limit: $limit
//       nextToken: $nextToken
//       sortDirection: $sortDirection
//       userId: $userId
//     ) {
//       items {
//         accepted
//         createdAt
//         deleted
//         info
//         role
//         shiftAppId
//         shiftId
//         startAt
//         stopAt
//         suspended
//         updatedAt
//         userId
//         __typename
//       }
//       nextToken
//       __typename
//     }
//   }
//   `;

//   userId: {attributeExists: true}
// export const listAgendaShifts = gql/* GraphQL */ `
// query ListAgendaShifts(
//     $filter: ModelAgendaShiftFilterInput
//     $limit: Int
//     $nextToken: String
//     $shiftId: ID
//     $sortDirection: ModelSortDirection
//   ) {
//     listAgendaShifts(
//       filter: $filter
//       limit: $limit
//       nextToken: $nextToken
//       shiftId: $shiftId
//       sortDirection: $sortDirection
//     ) {
//       items {
//         accepted
//         confirmed
//         createdAt
//         deleted
//         info
//         role
//         shiftId
//         startAt
//         stopAt
//         suspended
//         updatedAt
//         userId
//         __typename
//       }
//       nextToken
//       __typename
//     }
//   }
//   `;
//   export const shiftsByUser = gql /* GraphQL */ `
//   query ShiftsByUser(
//     $filter: ModelAgendaShiftFilterInput
//     $limit: Int
//     $nextToken: String
//     $sortDirection: ModelSortDirection
//     $startAt: ModelStringKeyConditionInput
//     $userId: ID!
//   ) {
//     shiftsByUser(
//       filter: $filter
//       limit: $limit
//       nextToken: $nextToken
//       sortDirection: $sortDirection
//       startAt: $startAt
//       userId: $userId
//     ) {
//       items {
//         confirmed
//         createdAt
//         deleted
//         shiftId
//         startAt
//         userId
//         __typename
//       }
//       nextToken
//       __typename
//     }
//   }
//   `;

//   export const requestsByUser = gql/* GraphQL */ `
//   query RequestsByUser(
//     $createdAt: ModelStringKeyConditionInput
//     $filter: ModelAgendaRequestFilterInput
//     $limit: Int
//     $nextToken: String
//     $sortDirection: ModelSortDirection
//     $userId: ID!
//   ) {
//     requestsByUser(
//       createdAt: $createdAt
//       filter: $filter
//       limit: $limit
//       nextToken: $nextToken
//       sortDirection: $sortDirection
//       userId: $userId
//     ) {
//       items {
//         createdAt
//         deleted
//         requestId
//         shiftId
//         userId
//         __typename
//       }
//       nextToken
//       __typename
//     }
//   }
//   `;